/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/***** AUTO FREE GIFT: Black Friday Only (12am–11:59pm EST → MST Conversion) *****/

/*
   EST 12:00am Nov 28  =  MST 10:00pm Nov 27
   EST 11:59pm Nov 28  =  MST  9:59pm Nov 28
*/

const now = new Date();

// Convert EST schedule to your store's Mountain Time
const startTime = new Date('2025-11-27T22:00:00-07:00'); // 10:00 PM MST Nov 27
const endTime   = new Date('2025-11-28T21:59:59-07:00'); // 9:59 PM MST Nov 28

if (now < startTime || now > endTime) {
  console.log("Auto-gift disabled: outside Black Friday window.");
} else {

  const FREE_GIFT_VARIANT = 46917831491837;   // your gift variant
  const THRESHOLD = 10000; // $100 in Shopify cents (after discounts)

  async function updateCartGift() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      let subtotal = cart.items_subtotal_price; 
      let hasGift = cart.items.some(i => i.variant_id === FREE_GIFT_VARIANT);

      if (subtotal >= THRESHOLD && !hasGift) {
        // add gift
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: FREE_GIFT_VARIANT, quantity: 1 }]
          })
        });
        location.reload(); 
      }

      if (subtotal < THRESHOLD && hasGift) {
        // remove gift
        const giftItem = cart.items.find(i => i.variant_id === FREE_GIFT_VARIANT);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });
        location.reload();
      }

    } catch (e) {
      console.error("Gift Auto-Add Error:", e);
    }
  }

  document.addEventListener('cart:updated', updateCartGift);
  updateCartGift();

} // END DATE WINDOW